import './Masthead.scss';

import * as React from 'react';
import * as Core from 'components/core';

type Props = {
  title: string;
  children?: React.ReactNode;
};

export default function Masthead(props: Props) {
  return (
    <div className="Masthead">
      <Core.PrimaryHeading>
        <h1>{props.title}</h1>
      </Core.PrimaryHeading>
      {props.children && (
        <div className="Masthead-content">{props.children}</div>
      )}
      <div className="Masthead-divider">
        <Core.PatternBorder width="100%" />
      </div>
    </div>
  );
}
